import { render, staticRenderFns } from "./ModalEliminarCertificado.vue?vue&type=template&id=baa31152&scoped=true&"
import script from "./ModalEliminarCertificado.vue?vue&type=script&lang=js&"
export * from "./ModalEliminarCertificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa31152",
  null
  
)

export default component.exports